/**
 * Parses either a bare `YYYY-MM-DD` date or a full ISO datetime (with a time
 * component and offset/`Z`) into a `Date`, or `null` when the input is
 * empty/unparseable.
 *
 * A bare date is anchored to UTC midnight (`T00:00:00Z` appended) so every
 * finder that treats a "day" field as a whole day — Grant Finder's
 * `closingDate`/`postedDate` — gets the same anchor regardless of the
 * caller's local timezone. A string that already carries a time component
 * (Job Finder's `datePosted`: `Jobs.JobPosting.DatePosted` is a SQL
 * `DATETIMEOFFSET`, serialised via `Date.prototype.toISOString()` in
 * `apps/MJAPI/src/resolvers/jobs/jobHydration.ts`'s `isoOrNull`, so it
 * always arrives as a full ISO datetime, never a bare date) is passed to
 * `new Date(...)` as-is — appending a second `T00:00:00Z` to an
 * already-complete ISO string produces an unparseable date string, which is
 * exactly the bug this helper exists to prevent (review finding,
 * 2026-09-03: job cards/detail read "posted NaN days ago").
 */
export function ParseIsoDate(value: string | null | undefined): Date | null {
    if (!value) return null;
    const raw = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T00:00:00Z` : value;
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}
